import React, { useEffect } from 'react'
 
const Metrika = () => {
  useEffect(() => {
    window.ym('replace_with_your_counter_id', 'hit')
  }, [])
 
  return null
}
 
export default Metrika